import { render, staticRenderFns } from "./AdminPointsCumul.vue?vue&type=template&id=72b0d6f0&"
import script from "./AdminPointsCumul.vue?vue&type=script&lang=js&"
export * from "./AdminPointsCumul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports